import { SyntheticEvent, useState } from 'react';
import logo from './assets/logo.png';

// Pre-load assets to ensure they are available when needed
// If this approach turns out to be not good enough, then we'll have to implement a real asset system, that keeps all of them in memory and prevents
// starting the dungeon without them.
export default function PreloadedAssets() {
	// fake state to force re-loading of assets that failed in the loading process
	const [attempts, setAttempts] = useState(0);

	const images = ['/titles/common.png', '/titles/uncommon.png', '/titles/rare.png', '/titles/epic.png', '/titles/legendary.png', '/duel-platform.png', logo];
	const audio = ['/boss-fight/8bit-boss-battle-normalized.mp3', '/startsound.mp3'];
	const videos = [
		'/boss-fight/orc_giant_atk.webm',
		'/boss-fight/orc_giant_idle.webm',
		'/boss-fight/orc_giant_yell.webm',
		'/effects/battle-1.webm',
		'/effects/battle-3.webm',
		'/effects/puff.webm',
		'/gift-animation.webm',
	];

	// play the asset silently to ensure all parts of it are loaded (by default the browser will only load a tiny fraction)
	async function playSilent(e: { currentTarget: HTMLAudioElement | HTMLVideoElement }) {
		const element = e.currentTarget;
		element.volume = 0;
		try {
			await element.play();
			console.log('asset loaded', element.src);
		} catch (err) {
			console.log('asset play failed', element.src, err, 'retrying in 1s');
			setTimeout(() => playSilent({ currentTarget: element }), 1_000);
		}
	}

	function handleError(e: SyntheticEvent<HTMLImageElement, Event> | SyntheticEvent<HTMLAudioElement, Event> | SyntheticEvent<HTMLVideoElement, Event>) {
		console.log('asset load failed', e.currentTarget.src, 'retrying in 1s');
		setTimeout(() => setAttempts(attempts + 1), Math.max(10_000, attempts * 1_000));
	}

	return (
		<div key={attempts} className="fixed top-0 left-0 w-1 h-1 opacity-0">
			{images.map((image) => (
				<img key={image} src={image} loading="eager" onError={handleError} />
			))}
			{audio.map((audio) => (
				<audio key={audio} src={audio} preload="metadata" onCanPlay={playSilent} onError={handleError} />
			))}
			{videos.map((video) => (
				<video key={video} src={video} preload="metadata" onCanPlay={playSilent} onError={handleError} />
			))}
		</div>
	);
}
